import { render } from "./Role.vue?vue&type=template&id=0722db43&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import "./Role.vue?vue&type=style&index=0&id=0722db43&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0722db43"

export default script